import { render, staticRenderFns } from "./detailall.vue?vue&type=template&id=9edce60a"
import script from "./detailall.vue?vue&type=script&lang=js"
export * from "./detailall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports